import {debug} from './utils';
/**
 *
 * @param  {...any} args
 * To enable log
 * First debug value should be true in Utils and
 * Logger last parameter should be true
 * Example for enable & disable -
 * Enable - logger("a","b",true)
 * Disable - logger("a","b",false) or logger("a","b")
 */
const logger = (...args) => {
   if (!debug) {
      return;
   }
   const status = args.slice(-1);
   if (status[0] === true) {
      args.pop();
      console.log(...args);
   }
   // console.log(...args);
};

export default logger;
